import firebase from 'firebase/app';
import 'firebase/auth';

import firebaseToken from '../../firebase.json';

const firebaseApp = firebase.initializeApp(firebaseToken);

export const auth = firebaseApp.auth();

export const refreshToken = async () => {
  if (auth.currentUser) {
    await auth.currentUser.getIdToken(true);
  }
};

export default firebaseApp;
